import { Socket, connect as io } from "socket.io-client";
import { Middleware } from "redux";
import {
  chatCallBack,
  incomingChat,
  incomingChatRoom,
  connected,
  setScrollPosition,
  incomingQueueChatRoom,
  allowReceiveChat,
  lastIncomingChatRoomOwner,
  firstIncomingChatRoom,
  addTalkbotNewAssignment,
} from "./chatSlice";
import { IIncomingRoom, IMessage, ITalkbotNewAssignment } from "./types";
import { sendHttpRequest } from "../../utils/httpRequest";

const getQueueChatRoom = ({ data }: any) => {
  return data.filter((a: any) => a.agentUserName == undefined);
};

const getChatRoom = ({ data }: any) => {
  return data.filter((a: any) => a.agentUserName != undefined);
};

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

const chatMiddleware: Middleware = (store) => {
  let socket: Socket;
  return (next) => (action) => {
    const { user } = store.getState().auth;
    const url = String(process.env.REACT_APP_CHAT_SOCKET);
    const userName = user?.username;
    const deviceId = user?.deviceId;
    const tenantId = user?.tenantId;
    const pathname = "/wss/chat/";
    const domain = new URL(url);
    const cleandomain = `${domain.protocol}//${domain.hostname}:${domain.port}`;
    const type = action?.type?.split("/")[1];

    const getUserState = async (username: any) => {
      const chatBaseUrl = String(process.env.REACT_APP_CHAT_SERVICE);

      await delay(3000);
      const response = await sendHttpRequest(
        chatBaseUrl,
        `/chat/user-state/${username}`,
        "get"
      );
      return response?.data[0];
    };

    let tries = 1;
    const maxtry = 3;

    switch (type) {
      case "chatWSConnecting":
        try {
          if (domain && user?.deviceId) {
            if (socket) socket.disconnect();
            socket = io(cleandomain, {
              path: pathname,
              transports: ["websocket", "polling", "flashsocket"],
            });
            socket.on("chat-callback", (data: any) => {
              store.dispatch(chatCallBack(data));
            });
            socket.on("incoming-chat-room", (data: IIncomingRoom[]) => {
              console.log("INCOMING CHAT ROOM ==>", data);
              const chatRoom = getChatRoom({ data });
              const queueChatRoom = getQueueChatRoom({ data });

              store.dispatch(firstIncomingChatRoom(chatRoom));
              store.dispatch(incomingChatRoom(chatRoom));
              store.dispatch(incomingQueueChatRoom(queueChatRoom));
            });
            socket.on("incoming-message", (data: IMessage[]) => {
              store.dispatch(setScrollPosition("bottom"));
              store.dispatch(incomingChat(data));
              if (data?.length > 0)
                store.dispatch(lastIncomingChatRoomOwner(data[0]));
            });
            socket.on("connect", async () => {
              console.log("connected chat");
              store.dispatch(connected(true));

              const result = await getUserState(user?.username);
              const isReceiveChat =
                String(result?.status).toLowerCase() != "offline";
              const isAllowReceiveChat = isReceiveChat;

              store.dispatch(allowReceiveChat(isAllowReceiveChat));
              socket.emit("join-room-agent", {
                deviceId,
                userName,
                tenantId,
                allowReceiveChat: isAllowReceiveChat,
              });
            });
            socket.on("disconnect", () => {
              console.log("disconnected chat");
              store.dispatch(connected(false));
            });
            socket.on("force-disconnect", () => {
              console.log("force disconnected chat");
              socket.disconnect();
            });
            socket.on(
              "talkbot-new-assignment",
              (data: ITalkbotNewAssignment) => {
                store.dispatch(
                  addTalkbotNewAssignment({ ...data, assignTime: new Date() })
                );
              }
            );
          }
        } catch (err) {
          console.log(err);
          tries++;
          if (tries > maxtry) store.dispatch(connected(false));
        }
        break;
      case "sendMessage":
        socket?.emit("chat", action.payload);
        break;
      case "resolveRoom":
        if (action.payload.roomId)
          socket?.emit("resolve-chat", {
            roomId: action.payload.roomId,
            tenantId,
            sessionId: action.payload.sessionId,
          });
        break;
      case "readMessage":
        socket?.emit("read-chat", {
          sessionId: action.payload.sessionId,
          messageId: action.payload.messageId,
        });
        break;
      case "typingMessage":
        socket?.emit("typing-chat", {
          sessionId: action.payload.sessionId,
          userName: action.payload.userName,
        });
        break;
      case "dequeueChat":
        socket?.emit("dequeue-chat", {
          sessionId: action.payload.sessionId,
          userName: action.payload.userName,
          tenantId,
        });
        break;
      case "assignChat":
        socket?.emit("assign-chat", {
          sessions: action.payload.sessions,
          assignTo: action.payload.assignTo,
          tenantId,
        });
        break;
      case "reassignChat":
        socket?.emit("reassign-chat", {
          sessions: action.payload.sessions,
          assignFrom: action.payload.assignFrom,
          assignTo: action.payload.assignTo,
          tenantId,
        });
        break;
      case "monitoringChat":
        socket?.emit("join-monitoring", {
          userName,
          tenantId,
          sessionId: action.payload.sessionId,
          roomId: action.payload.roomId,
        });
        break;
      case "chatWSDisconnectin":
        socket?.disconnect();
        break;
      case "chatWSOffline":
        store.dispatch(allowReceiveChat(false));
        socket?.emit("join-room-agent", {
          deviceId,
          userName,
          tenantId,
          allowReceiveChat: false,
        });
        break;
      case "chatWSOnline":
        store.dispatch(allowReceiveChat(true));
        socket?.emit("join-room-agent", {
          deviceId,
          userName,
          tenantId,
          allowReceiveChat: true,
        });
        break;
    }
    next(action);
  };
};

export default chatMiddleware;
